module.exports = __webpack_public_path__ + "static/media/icon_default.67539d33.png";